<template>
	<div class="advert-manage-container">
		<div style="margin-bottom: 20px">
			<!-- 标签页 -->
			<el-button-group>
				<el-button
					v-for="tab in tabs"
					:key="tab.name"
					:type="activeTab === tab.name ? 'primary' : ''"
					size="small"
					@click="tabClick(tab.name)">
					{{ tab.label }}
				</el-button>
			</el-button-group>
		</div>
		<InfoCards :data="list" />
		<el-card style="margin-bottom: 20px">
			<div slot="header">{{ activeTab === '1' ? '支出' : '收入' }}预算与实际对比</div>
			<div style="height: 300px">
				<BaseChart :option="baseOption" />
			</div>
		</el-card>
		<!-- 表格 -->
		<BaseTable
			:selection="false"
			:actions="{
				add: true,
				export: true,
				operation: true,
			}"
			:loading="loading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="pageNum"
			:pageSize="pageSize"
			@page-change="pageChange"
			@size-change="sizeChange"
			@add="handleAdd"
			@export="handleExport">
			<div slot="header-left">
				<span>{{ activeTab === '1' ? '支出' : '收入' }}预算明细</span>
			</div>
			<div slot="header-right">
				<el-date-picker
					v-model="month"
					type="month"
					placeholder="选择月"
					size="small"
					value-format="YYYY-MM"
					style="margin-right: 10px; width: 150px"></el-date-picker>
			</div>
			<template #usageRate="{ row }">
				<el-progress :percentage="row.usageRate" color="#67C23A" />
			</template>
			<template #operation="{ row }">
				<el-button type="text" @click="handleChange(row)">调整</el-button>
			</template>
		</BaseTable>

		<BudgetManagementDialog :dialogVisible.sync="dialogVisible" />
		<BudgetManagementAdjustDialog :dialogVisible.sync="dialogAdjustVisible" />
	</div>
</template>

<script>
	import dayjs from 'dayjs';
	import BudgetManagementDialog from '@/components/assets/budgetManagementDialog.vue';
	import BudgetManagementAdjustDialog from '@/components/assets/budgetManagementAdjustDialog.vue';
	export default {
		name: 'BudgetManagement',
		components: {
			BudgetManagementDialog,
			BudgetManagementAdjustDialog,
		},
		data() {
			return {
				activeTab: '1',
				tabs: [
					{ name: '1', label: '支出预算' },
					{ name: '2', label: '收入预算' },
				],
				dialogVisible: false,
				dialogAdjustVisible: false,
				loading: false,
				list: [
					{
						label: '年度收入预算',
						value: '11090万',
						color: '#409eff',
					},
					{
						label: '实际收入',
						value: '10725万',
						color: '#67c23a',
					},
					{
						label: '预算差额',
						value: '365万',
						color: '#e6a23c',
					},
					{
						label: '执行率',
						value: '96.7%',
						color: '#f56c6c',
					},
				],
				month: dayjs().format('YYYY-MM'),
				total: 0,
				pageNum: 1,
				pageSize: 10,
				columns: [
					{ prop: 'subject', label: '预算科目' },
					{ prop: 'budget', label: '月度预算(万元)' },
					{ prop: 'used', label: '已使用(万元)' },
					{ prop: 'remaining', label: '剩余金额(万元)' },
					{ prop: 'usageRate', label: '使用比例', slot: 'usageRate' },
				],
				tableData: [
					{
						subject: '物业管理费',
						budget: 200,
						used: 91.0,
						remaining: 109.0,
						usageRate: 45.5,
					},
					{
						subject: '设备维护费',
						budget: 150,
						used: 55.0,
						remaining: 95.0,
						usageRate: 36.7,
					},
					{
						subject: '绿化养护费',
						budget: 80,
						used: 36.0,
						remaining: 44.0,
						usageRate: 45.0,
					},
				],
			};
		},
		computed: {
			baseOption() {
				return {
					grid: {
						bottom: '20%',
						right: '5%',
						top: '5%',
						left: '5%',
					},
					tooltip: {
						trigger: 'axis',
					},
					legend: {
						data: ['预算', '实际'],
						bottom: '2%',
						itemWidth: 14,
						itemGap: 60,
					},
					xAxis: [
						{
							type: 'category',
							data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月'],
							splitLine: {
								show: true,
								lineStyle: { type: 'dashed' },
							},
						},
					],
					yAxis: {
						type: 'value',
						splitLine: {
							lineStyle: { type: 'dashed' },
						},
					},
					series: [
						{
							name: '预算',
							type: 'bar',
							barWidth: '20%',
							color: '#4080FF',
							data: [320, 302, 301, 334, 390, 330, 320],
						},
						{
							name: '实际',
							type: 'bar',
							barWidth: '20%',
							color: '#16A34A',
							data: [120, 132, 101, 134, 90, 230, 210],
						},
					],
				};
			},
		},
		created() {},
		methods: {
			tabClick(name) {
				this.activeTab = name;
			},
			dayjs,
			pageChange(page) {
				this.pageNum = page;
			},
			sizeChange(size) {
				this.pageSize = size;
			},
			handleClick() {},
			handleAdd() {
				this.dialogVisible = true;
			},
			handleExport() {},
			handleChange(row) {
				this.dialogAdjustVisible = true;
			},
		},
	};
</script>

<style scoped lang="scss">
	.advert-manage-container {
		padding: 20px;
		color: #1c1c1c;
		text-align: left;
	}
</style>
